import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Icon, Checkbox, Table, TableBody, TableHead, FormControl, TableCell, TableRow, Tabs, Tab } from '@material-ui/core';
import Select from 'react-select';
import {IconButton,Tooltip} from '@material-ui/core';
import {AddCircle,RemoveCircle} from '@material-ui/icons';
import SaveIcon from '@material-ui/icons/Save';
import { Typography, DialogActions, TextField } from '@material-ui/core';
import { LayoutContext } from "App/Layout/store";
import { GetUsuarios, GetPerfiles, GetUsuariosCsv } from 'App/Administracion/Actions';
import { AdministracionContext } from "App/Administracion/store";
import CloseButtonDialog from "App/components/CloseButtonDialog";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import LinearProgress from '@material-ui/core/LinearProgress';
import Swal from 'sweetalert2'
import _ from 'underscore'
import { GetTags } from "App/Layout/Actions";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    textAlignRight: {
        textAlign: "right"
    },
    iconHover: {
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    },
    nopadding: {
        padding: 0
    },
    card: {
        borderRadius: 12,
        minWidth: 300,
        maxWidth: 300,
        textAlign: 'center',
        margin: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 3,
    },
    avatar: {
        width: 60,
        height: 60,
        margin: 'auto',
    },
    heading: {
        fontSize: 18,
        fontWeight: 'bold',
        letterSpacing: '0.5px',
        marginTop: 8,
        marginBottom: 0,
    },
    subheader: {
        fontSize: 14,
        marginBottom: '0.875em',
    },
    statLabel: {
        fontSize: 12,
        fontWeight: 500,
        fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        margin: 0,
    },
    statValue: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 4,
        letterSpacing: '1px',
    },
});

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}


function Usuarios(props) {
    const { classes, theme } = props;
    const administracionContext = useContext(AdministracionContext);
    const layoutContext = useContext(LayoutContext);
    const [permisosOriginal, setPermisosOriginal] = useState()
    const [usuarios, setUsuarios] = useState([])
    const [empresas, setEmpresas] = useState([])
    const [perfiles, setPerfiles] = useState([])
    const [permisos, setPermisos] = useState({})
    const [tab, setTab] = useState(0)
    const [cargando, setCargando] = useState(false)
    const [clave, setClave] = useState({ c1: null, c2: null })
    const [abreCambioContrasena, setAbreCambioContrasena] = useState(false)
    const [abreCreaUsuario, setAbreCreaUsuario] = useState(false)
    const [abreCreaPerfil, setAbreCreaPerfil] = useState(false)
    const [creaUsuario, setCreaUsuario] = useState({})
    const [creaPerfil, setCreaPerfil] = useState({})
    const [cambios, setCambios] = useState([])

    useEffect(() => {
        getUsuarios()
        GetTags(layoutContext.dispatch)
    }, []);

    useEffect(() => {
        if (abreCambioContrasena) {
            setClave({ c1: null, c2: null })
        }
    }, [abreCambioContrasena]);

    function getUsuarios() {
        setCargando(true)
        GetUsuarios(u => {
            setUsuarios(u.Listado)
            setPerfiles(u.Perfiles.sort((a, b) => a.IdEmpresa - b.IdEmpresa).sort((a, b) => a.Name - b.Name))
            setEmpresas(u.Empresas)
            getPerfiles()
        })
    }
    function getPerfiles() {
        setCargando(true)
        GetPerfiles(p => {
            setPermisos(p)
            setPermisosOriginal(JSON.parse(JSON.stringify(p)))
            setCargando(false)
        })
    }

    function crearUsuario(datos) {
        setCargando(true)
        axios.post("/api/Administracion/Usuario/agregar", datos).then(o => {
            getUsuarios()
            setCargando(false)
            setCreaUsuario({})
            Swal.fire("","Cambios realizados exitosamente","success")
        }).catch(e => {
            /*alert(e.response.data.Mensaje)*/
            setCargando(false)
        });
    }
    function crearPerfil(datos) {
        setCargando(true)
        axios.post("/api/Administracion/Perfiles/agregar", datos).then(o => {
            getPerfiles()
            getUsuarios()
            setCargando(false)
            setCreaPerfil({})
            Swal.fire("","Cambios realizados exitosamente","success")
        }).catch(e => {
            /*alert(e.response.data.Mensaje)*/
            setCargando(false)
        });
    }

    function eliminarPerfil(datos) {
        setCargando(true)
        axios.post("/api/Administracion/Perfiles/Eliminar", datos).then(o => {
            getPerfiles()
            getUsuarios()
            setCargando(false)
            Swal.fire("","Cambios realizados exitosamente","success")
        }).catch(e => {
            setCargando(false)
        });
    }

    function editarPerfil(datos) {
        setCargando(true)
        axios.post("/api/Administracion/Perfiles/editar", datos).then(o => {
            getPerfiles()
            setCargando(false)
            Swal.fire("","Cambios realizados exitosamente","success")
        }).catch(e => {
            setCargando(false)
        });
    }

    function editarUsuario(id, datos) {
        setCargando(true)
        axios.post("/api/Administracion/Usuario/" + id, datos).then(o => {
            getUsuarios()
            setCargando(false)
            Swal.fire("","Cambios realizados exitosamente","success")
        }).catch(e => {
            /*alert(e.response.data.Mensaje)*/
            setCargando(false)
        });
    }

    return (
        <div>
            <Tabs
                value={tab}
                onChange={(e, v) => setTab(v)}
                indicatorColor="primary"
                textColor="primary"
                centered
                variant="fullWidth"
            >
                <Tab label="Usuarios" />
                <Tab label="Perfiles" />
            </Tabs>
            {tab == 0 ? <TabContainer>
                <Grid container spacing={24}>
                    <Grid item sm={12}>
                        <Typography variant="h5">Usuarios</Typography>
                    </Grid>
                    <Grid item sm={12} className={classes.textAlignRight}>
                    {/* ---- BOTÓN DE DESCARGA AÑADIDO ---- */}
                    <Tooltip title="Descargar Listado CSV">
                             {/* Usando un Button normal de Material-UI */}
                             <Icon color="primary" aria-label="Add"
                                 className={classes.iconHover} // Añade espacio a la izquierda
                                 onClick={GetUsuariosCsv} // Llama a la acción modificada
                                 disabled={cargando} // Deshabilita mientras carga
                             >
                                 <CloudDownloadIcon />
                             </Icon>
                         </Tooltip>
                         {/* ---- FIN BOTÓN DE DESCARGA ---- */}
                        <Tooltip title="Agregar usuario">
                            <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                                evt.preventDefault();
                                setAbreCreaUsuario(true)
                            }}>
                                <AddCircle />
                            </Icon>
                        </Tooltip>
                    </Grid>
                    {cargando && <LinearProgress variant="query" />}
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Usuario</TableCell>
                                <TableCell>Correo</TableCell>
                                <TableCell>Empresas</TableCell>
                                <TableCell>Perfiles</TableCell>
                                <TableCell>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {usuarios.map((o, ix) => {
                                return <TableRow key={ix}>
                                    <TableCell>{o.UserName}</TableCell>
                                    <TableCell>{o.Email}</TableCell>
                                    <TableCell><Select
                                        isMulti
                                        options={empresas.map(m => ({ value: m.IdEmpresa, label: m.RazonSocial }))}
                                        value={o.Empresas.map(m => {
                                            var emp = empresas.find(o => o.IdEmpresa == m)
                                            return { value: emp?.IdEmpresa, label: emp?.RazonSocial }
                                        })}
                                        onChange={(e, v) => {
                                            if (e.length) {
                                                var us = [...usuarios]
                                                us[ix].Empresas = e.map(d => d.value);
                                                setUsuarios(us)
                                                if (v.removedValue) {
                                                    editarUsuario(o.IdUsuario, { quitarempresa: v.removedValue.value })
                                                } else {
                                                    editarUsuario(o.IdUsuario, { agregarempresa: v.option.value })
                                                }
                                            }
                                        }}
                                    /></TableCell>
                                    <TableCell><Select
                                        isMulti
                                        options={perfiles.filter(p => o.Empresas.includes(p.IdEmpresa)).map(m => {
                                            var emp = empresas.find(o => o.IdEmpresa == m.IdEmpresa)
                                            return { value: m.IdPerfil, label: `${emp?.RazonSocial} - ${m.Name}` }
                                        })}
                                        value={o.Perfiles.filter(p => o.Empresas.includes(p.IdEmpresa)).map(m => {
                                            var emp = empresas.find(o => o.IdEmpresa == m.IdEmpresa)
                                            return { value: m.IdPerfil, label: `${emp?.RazonSocial} - ${m.Name}` }
                                        })}
                                        onChange={e => {
                                            var us = [...usuarios]
                                            us[ix].Perfiles = perfiles.filter(p => e.some(d => d.value == p.IdPerfil));
                                            setUsuarios(us)
                                            editarUsuario(o.IdUsuario, { perfiles: us[ix].Perfiles.map(d => d.IdPerfil) })
                                        }}
                                    /></TableCell>
                                    <TableCell>
                                        <CardActions>
                                            <Button size="small" variant="contained" disabled={cargando} onClick={() => setAbreCambioContrasena(o.IdUsuario)}>Cambiar Contraseña</Button>
                                            <Button size="small" variant="contained" disabled={cargando} onClick={e => editarUsuario(o.IdUsuario, { activo: !o.Activo })} color="secondary">{o.Activo ? "Desactivar" : "Activar"} Usuario</Button>
                                        </CardActions>
                                    </TableCell>
                                </TableRow>
                            })}
                        </TableBody>
                    </Table>
                </Grid>
            </TabContainer> :
                <TabContainer>
                    <Grid container spacing={24}>
                        <Grid item sm={12}>
                            <Typography variant="h5">Perfiles</Typography>
                        </Grid>
                        <Grid item sm={12} className={classes.textAlignRight}>
                            {cambios.length || !_.isEqual(permisos.Perfiles, permisosOriginal.Perfiles) ? <Tooltip title="Guardar Cambios">
                                <Icon color="primary" aria-label="Save" className={classes.iconHover} onClick={(evt) => {
                                    evt.preventDefault();
                                    if(window.confirm("¿Desea guardar estos cambios?"))
                                        editarPerfil({permisos:cambios, perfiles: permisos.Perfiles.map(e=>({id_perfil: e.id_perfil, tags: e.tags}))})
                                }}>
                                    <SaveIcon />
                                </Icon>
                            </Tooltip> : null}
                            <Tooltip title="Agregar perfil">
                                <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
                                    evt.preventDefault();
                                    setAbreCreaPerfil(true)
                                }}>
                                    <AddCircle />
                                </Icon>
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid style={{ overflow: "auto" }}>
                        {cargando && <LinearProgress variant="query" />}
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Perfil</TableCell>
                                    {layoutContext.state.datosEmpresa?.Permisos?.filter(e => !e.Admin)?.reverse()?.map(pe => <TableCell style={{ minWidth: "200px" }}>
                                        <strong>{pe.Nombre}</strong>
                                        <Grid container spacing={24}>
                                            {pe.BLectura ? <Grid item xs={6}>
                                                Lectura
                                            </Grid> : null}
                                            {pe.BEscritura ? <Grid item xs={6}>
                                                Escritura
                                            </Grid> : null}
                                        </Grid>
                                    </TableCell>)}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {permisos.Perfiles?.map(p => <TableRow>
                                    <TableCell style={{minWidth:250}}>{p.Name}
                                    <Select
                                                    placeholder='Etiquetas'
                                                    styles={{
                                                        // Fixes the overlapping problem of the component
                                                        menu: provided => ({ ...provided, zIndex: 9999 })
                                                      }}
                                                    isMulti
                                                    value={p.tags.map(e => ({ label: layoutContext.state.tags.find(t => t.id_tag == e)?.nombre, value: e }))}
                                                    options={layoutContext.state.tags.map(e => ({ label: e.nombre, value: e.id_tag }))}
                                                    onChange={e => {
                                                        var Perfiles = [...permisos.Perfiles];
                                                        var pe = Perfiles.find(pe => pe.id_perfil == p.id_perfil)
                                                        pe.tags = e.map(o => o.value)
                                                        setPermisos({...permisos, Perfiles})
                                                    }}
                                                />
                                    <br/>
                                    <IconButton onClick={(event) => {
                                        if(window.confirm("¿Desea eliminar este perfil?"))
                                            eliminarPerfil({id_perfil: p.id_perfil})
                                    }}>
                            <Icon color="error">
                            <RemoveCircle/>
                            </Icon>
                        </IconButton>
                                    </TableCell>
                                    {layoutContext.state.datosEmpresa?.Permisos?.filter(e => !e.Admin)?.reverse()?.map(pe => <TableCell style={{ minWidth: "200px" }}>
                                        <Grid container spacing={24}>
                                            {pe.BLectura ? <Grid item xs={6}>
                                                <Checkbox
                                                    checked={permisos.Permisos.some(pp => pp.id_perfil == p.id_perfil && pp.nombre_permiso == pe.Nombre && pp.b_lectura && pe.BLectura)}
                                                    onChange={e => {
                                                        var pd = { ...permisos }
                                                        var per = pd.Permisos.find(o => o.id_perfil == p.id_perfil && o.nombre_permiso == pe.Nombre);
                                                        if (!per) {
                                                            per = { id_perfil: p.id_perfil, nombre_permiso: pe.Nombre }
                                                            pd.Permisos.push(per)
                                                        }
                                                        per.b_lectura = e.target.checked;
                                                        setPermisos(pd)
                                                        // agregamos el cambio
                                                        var ca = [...cambios]
                                                        var c = ca.find(o => o.id_perfil == p.id_perfil && o.nombre_permiso == pe.Nombre)
                                                        if (!c) {
                                                            ca.push(per)
                                                            c = per;
                                                        }
                                                        c.b_lectura = per.b_lectura
                                                        setCambios(ca)
                                                    }}
                                                    color="default" value="checkedG" />
                                            </Grid> : null}
                                            {pe.BEscritura ? <Grid item xs={6}>
                                                <Checkbox
                                                    checked={permisos.Permisos.some(pp => pp.id_perfil == p.id_perfil && pp.nombre_permiso == pe.Nombre && pp.b_escritura && pe.BEscritura)}
                                                    onChange={e => {
                                                        var pd = { ...permisos }
                                                        var per = pd.Permisos.find(o => o.id_perfil == p.id_perfil && o.nombre_permiso == pe.Nombre);
                                                        if (!per) {
                                                            per = { id_perfil: p.id_perfil, nombre_permiso: pe.Nombre }
                                                            pd.Permisos.push(per)
                                                        }
                                                        per.b_escritura = e.target.checked;
                                                        setPermisos(pd)
                                                        // agregamos el cambio
                                                        var ca = [...cambios]
                                                        var c = ca.find(o => o.id_perfil == p.id_perfil && o.nombre_permiso == pe.Nombre)
                                                        if (!c) {
                                                            ca.push(per)
                                                            c = per;
                                                        }
                                                        c.b_escritura = per.b_escritura
                                                        setCambios(ca)
                                                    }}
                                                    color="default" value="checkedG" />
                                            </Grid> : null}
                                        </Grid>
                                        {permisos.Permisos?.some(pp => pp.id_perfil == p.id_perfil && pp.nombre_permiso == pe.Nombre && (pp.b_lectura || pp.b_escritura)) ? <Grid container spacing={24}>
                                            <Grid item xs={12}>
                                            <FormControl fullWidth className={classes.formControl}>
                                                <Select
                                                    placeholder='Tipos de Documento'
                                                    styles={{
                                                        // Fixes the overlapping problem of the component
                                                        menu: provided => ({ ...provided, zIndex: 9999 })
                                                      }}
                                                    isMulti
                                                    value={permisos.Permisos.find(pp => pp.id_perfil == p.id_perfil && pp.nombre_permiso == pe.Nombre)?.tiposDoc?.map(e => ({ label: layoutContext.state.tiposDoc.find(t => t.ID == e)?.Nombre||"Documentos Propios", value: e }))}
                                                    options={[...layoutContext.state.tiposDoc.filter(e => e.Electronico), { Nombre: "Documentos Propios", ID: 0 }].map(e => ({ label: e.Nombre, value: e.ID }))}
                                                    onChange={e => {
                                                        var pd = { ...permisos }
                                                        var per = pd.Permisos.find(o => o.id_perfil == p.id_perfil && o.nombre_permiso == pe.Nombre);
                                                        per.tiposDoc = e.map(o => o.value)
                                                        setPermisos(pd)
                                                        // agregamos el cambio
                                                        var ca = [...cambios]
                                                        var c = ca.find(o => o.id_perfil == p.id_perfil && o.nombre_permiso == pe.Nombre)
                                                        if (!c) {
                                                            ca.push(per)
                                                            c = per;
                                                        }
                                                        c.tiposDoc = per.tiposDoc
                                                        setCambios(ca)
                                                    }}
                                                />
                                                </FormControl>
                                            </Grid>
                                        </Grid> : null}
                                    </TableCell>)}
                                </TableRow>)}
                            </TableBody>
                        </Table>
                    </Grid>
                </TabContainer>}
            <CloseButtonDialog open={abreCambioContrasena} onClose={() => setAbreCambioContrasena(false)} closeButton title={"Cambiar Contraseña"} content={<Typography>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Ingrese Clave"
                    type="password"
                    margin="dense"
                    value={clave.c1}
                    onChange={e => {
                        setClave({ ...clave, c1: e.target.value })
                    }
                    }
                />
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Repita Clave"
                    type="password"
                    margin="dense"
                    value={clave.c2}
                    onChange={e => {
                        setClave({ ...clave, c2: e.target.value })
                    }
                    }
                />
            </Typography>} footer={<DialogActions>
                <Button size="small" disabled={cargando} onClick={() => setAbreCambioContrasena(false)}>Cancelar</Button>
                <Button size="small" disabled={cargando || !clave.c1 || clave.c1 != clave.c2} color="primary" onClick={() => { editarUsuario(abreCambioContrasena, { clave: clave.c1 }); setAbreCambioContrasena(false) }}>Guardar</Button>
            </DialogActions>} size="sm" />
            <CloseButtonDialog open={abreCreaPerfil} onClose={() => setAbreCreaPerfil(false)} closeButton title={"Crear Perfil"} content={<Typography>
                <Grid container>
                    <Grid item xs={12} style={{ margin: 8 }}>
                        <TextField
                            variant="outlined"
                            label="Nombre del Perfil"
                            type="text"
                            fullWidth
                            margin="normal"
                            value={creaPerfil.nombre || ""}
                            onChange={e => { setCreaPerfil({ ...creaPerfil, nombre: e.target.value }) }}
                        />
                    </Grid>
                </Grid>
            </Typography>} footer={<DialogActions>
                <Button size="small" disabled={cargando} onClick={() => setAbreCreaPerfil(false)}>Cancelar</Button>
                <Button size="small" disabled={cargando || !creaPerfil.nombre || creaPerfil.nombre.length < 3} color="primary" onClick={() => { crearPerfil(creaPerfil); setAbreCreaPerfil(false) }}>Guardar</Button>
            </DialogActions>} />
            <CloseButtonDialog open={abreCreaUsuario} onClose={() => setAbreCreaUsuario(false)} closeButton title={"Crear Usuario"} fullWidth content={<Typography>
                <Grid container>
                    <Grid item xs={5} style={{ margin: 8 }}>
                        <TextField
                            variant="outlined"
                            label="Nombre de Usuario"
                            type="text"
                            fullWidth
                            margin="normal"
                            value={creaUsuario.usuario || ""}
                            onChange={e => { setCreaUsuario({ ...creaUsuario, usuario: e.target.value }) }}
                        />
                    </Grid>
                    <Grid item xs={5} style={{ margin: 8 }}>
                        <TextField
                            variant="outlined"
                            label="Correo"
                            type="text"
                            fullWidth
                            margin="normal"
                            value={creaUsuario.correo || ""}
                            onChange={e => { setCreaUsuario({ ...creaUsuario, correo: e.target.value }) }}
                        />
                        {creaUsuario.correo && !validateEmail(creaUsuario.correo || "") && <Typography variant="caption" color="secondary">Correo inválido</Typography>}
                    </Grid>
                    <Grid item xs={5} style={{ margin: 8 }}>
                        <TextField
                            variant="outlined"
                            label="Nombre"
                            type="text"
                            fullWidth
                            margin="normal"
                            value={creaUsuario.nombre || ""}
                            onChange={e => { setCreaUsuario({ ...creaUsuario, nombre: e.target.value }) }}
                        />
                    </Grid>
                    <Grid item xs={5} style={{ margin: 8 }}>
                        <TextField
                            variant="outlined"
                            label="Apellido"
                            type="text"
                            fullWidth
                            margin="normal"
                            value={creaUsuario.apellido || ""}
                            onChange={e => { setCreaUsuario({ ...creaUsuario, apellido: e.target.value }) }}
                        />
                    </Grid>
                    <Grid item xs={5} style={{ margin: 8 }}>
                        <TextField
                            variant="outlined"
                            label="Clave"
                            type="password"
                            fullWidth
                            margin="normal"
                            value={creaUsuario.clave || ""}
                            onChange={e => { setCreaUsuario({ ...creaUsuario, clave: e.target.value }) }}
                        />
                    </Grid>
                    <Grid item xs={5} style={{ margin: 8 }}>
                        <TextField
                            variant="outlined"
                            label="Repita Clave"
                            type="password"
                            fullWidth
                            margin="normal"
                            value={creaUsuario.clave2 || ""}
                            onChange={e => { setCreaUsuario({ ...creaUsuario, clave2: e.target.value }) }}
                        />
                    </Grid>
                </Grid>
            </Typography>} footer={<DialogActions>
                <Button size="small" disabled={cargando} onClick={() => setAbreCreaUsuario(false)}>Cancelar</Button>
                <Button size="small" disabled={cargando || !creaUsuario.usuario || creaUsuario.usuario.length < 5 || !creaUsuario.nombre || !creaUsuario.apellido || !creaUsuario.clave || creaUsuario.clave != creaUsuario.clave2} color="primary" onClick={() => { crearUsuario(creaUsuario); setAbreCreaUsuario(false) }}>Guardar</Button>
            </DialogActions>} />
        </div>
    )
}

Usuarios.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Usuarios);